import {
  Avatar,
  AvatarFallback,
  Badge,
  Icon,
} from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";
import dayjs from "dayjs";
import type { RegistryType } from "@/schemas/digital-files/registry";

export const AssociatesInfo = ({
  associates,
}: {
  associates?: RegistryType["associates"];
}) => {
  if (!associates || associates.length === 0) {
    return <span>Sin personas asociadas</span>;
  }

  const uniqueUsers = associates.filter(
    (a, i, arr) =>
      arr.findIndex((b) => b.applicant_id === a.applicant_id) === i,
  );

  return (
    <div className="flex flex-col sm:flex-row justify-center sm:justify-start items-center gap-1">
      <span>Personas asociadas:</span>
      <div
        className="flex relative items-center h-5"
        style={{ width: Math.min(uniqueUsers.length, 3) * 10 + 18 + "px" }}
      >
        {Array.from({ length: Math.min(uniqueUsers.length, 3) }).map(
          (_, index) => {
            const user = uniqueUsers[index];
            return (
              <Avatar
                key={`avatar-${index + 1}`}
                size="2xs"
                shape="circle"
                className="absolute top-0"
                style={{ left: 12 * index + "px" }}
              >
                <AvatarFallback
                  className={user?.is_owner ? "bg-[#caede3]" : "bg-[#D8E6FD]"}
                  shape="circle"
                  color={user?.is_owner ? "success" : "action"}
                >
                  {user
                    ? user.applicant?.first_name?.charAt(0).toUpperCase()
                    : "S"}
                </AvatarFallback>
              </Avatar>
            );
          },
        )}
      </div>
      <p
        className={cn(
          "text-action hidden md:block truncate",
          uniqueUsers.length === 1 && uniqueUsers[0].is_owner && "text-success",
        )}
      >
        {uniqueUsers.length === 1
          ? `${uniqueUsers[0]?.applicant?.first_name || ""} ${uniqueUsers[0]?.applicant?.last_name || ""}`
          : "+" + uniqueUsers.length + " usuarios"}
      </p>
    </div>
  );
};

export const RelatedRegistriesInfo = ({
  registries,
}: {
  registries?: RegistryType["related_registries"];
}) => {
  if (!registries || registries.length === 0) {
    return <span>Sin registros asociados</span>;
  }

  return (
    <div className="flex flex-col sm:flex-row justify-center sm:justify-start items-center gap-1">
      <span>Registros asociados:</span>
      <Badge size="sm">
        {registries.length}
        <Icon type="fas" name="folder" size="xs" />
      </Badge>
    </div>
  );
};

export const LastUpdateInfo = ({ data }: { data: RegistryType }) => {
  if (!data.updated_at) {
    return <span>Sin actualizaciones</span>;
  }

  return (
    <div className="flex gap-1 flex-col items-center sm:flex-row sm:items-start">
      <span>Última actualización:</span>
      <span className="capitalize">
        {dayjs(data.updated_at).format("MMM DD, YYYY")}
      </span>
      {(data.created_by || data.updated_by) && (
        <>
          <span>por</span>
          <span className="text-action">
            {data.updated_by ? data.updated_by?.name : data.created_by?.name}
          </span>
        </>
      )}
    </div>
  );
};
